<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="6">
        <site-filter store="premium" :dependsOnSiteGroups="false" />
      </v-col>
      <v-col cols="3">
        <date-filter
          store="premium"
          store-getter="getYear"
          store-updater="updateYear"
          :is-range="false"
          format="year"
          :years-ago="5"
          :max="currentYear"
          @change="onYearChange"
        />
      </v-col>
      <v-col cols="3" class="d-flex">
        <v-spacer />
        <apply-filters :disabled="isLoading" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import useAxios from "@/hooks/useAxios";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import SiteFilter from "@/components/common/filters/SiteFilter";
import DateFilter from "@/components/common/filters/DateFilter";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    SiteFilter,
    DateFilter,
  },
  data() {
    return {
      currentYear: new Date().getFullYear().toString(),
    };
  },
  setup() {
    const { axiosGet, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
    };
  },
  methods: {
    onYearChange() {
      this.$store.dispatch("common/updateApplyFilters", true);
    },
    async initSiteGroup() {
      const {
        data: { items },
      } = await this.axiosGet("/site-groups/", {
        search: "Report Weekly Email",
      });

      await this.$store.dispatch(
        "premium/updateSiteGroups",
        items.map((item) => item.id)
      );
    },
  },
  computed: {
    siteIds() {
      return this.$store.getters["premium/getSites"];
    },
  },
  watch: {
    siteIds(newVal) {
      if (newVal.length > 0) {
        return;
      }

      this.initSiteGroup();
    },
  },
};
</script>

<style></style>
